import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UTILS } from 'src/app/entities/Utils';


@Component({
  selector: 'app-navigator',
  templateUrl: './navigator.component.html',
  styleUrls: ['./navigator.component.css']
})
export class NavigatorComponent implements OnInit, OnChanges {

  @Input() navigator : any;
  @Input() companyNameSelected : string | undefined;
  @Input() childSelected : string | undefined;
  
  listNav : {id: string, label: string}[] | undefined;

  title: string ="";

  @Output() clickNav : EventEmitter<string> = new EventEmitter();

  constructor(private translate: TranslateService) {}

  async ngOnInit() {
  	await this.checkNavigator();
    await this.getTitle();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if(changes.navigator){
      this.navigator = changes.navigator.currentValue;
      await this.checkNavigator();
      await this.getTitle();
    }
  }
  
  async checkNavigator(){
    if(this.navigator instanceof Array){
      this.listNav = [];
      for(let v of (this.navigator as {id: string, label: string}[])){
        let translateVal = v.label.replace(" ","");
        v.label.replace(translateVal, await new UTILS().getTranslateTitle(this.translate, translateVal));
        if(this.listNav!.filter(a => a.id == v.id).length == 0){
          this.listNav!.push(v);
        }
      }
    }
  }

  async getTitle(){
    if(typeof this.navigator === 'string' || this.navigator instanceof String){
      this.title = '';
      let list = (this.navigator as string).split("\/");
      // console.log("ADESSO");
      for(let v of list){
        let oldVal = v;
        let translateVal = v.replace(" ","");
        this.title += oldVal.replace(translateVal, await new UTILS().getTranslateTitle(this.translate, translateVal));
        if(list.indexOf(v) != list.length -1){
          this.title +="/"
        }
      }
    } else {
      // console.log(this.navigator.constructor.name)
    }
  }

}
